// Edit form rendered inline as a table row. Inputs hold a local draft;
// Save calls the PATCH and the parent swaps back to ItemRowView with the
// returned row. Cancel discards the draft. Schedule + roll-grooved fields
// stay implicit for now (Phase 5 polish exposes them).
import { Check, X } from "lucide-react";
import type { TakeoffItemDto } from "../../../../../shared/types/pipe-takeoff";

const CATEGORIES = [
  "pipe",
  "fitting",
  "flange",
  "roll_grooved",
  "valve",
  "specialty",
  "air_bottle",
  "stud_drain",
] as const;

interface Props {
  draft: TakeoffItemDto;
  busy: boolean;
  onChange: (next: TakeoffItemDto) => void;
  onSave: () => void;
  onCancel: () => void;
}

const inputBase: React.CSSProperties = { height: 30 };

export function ItemRowEdit({ draft, busy, onChange, onSave, onCancel }: Props) {
  return (
    <tr>
      <td />
      <td>
        <select
          className="bsp-input"
          style={{ ...inputBase, fontSize: 12 }}
          value={draft.category}
          onChange={(e) =>
            onChange({ ...draft, category: e.target.value as TakeoffItemDto["category"] })
          }
        >
          {CATEGORIES.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </td>
      <td>
        <input
          className="bsp-input"
          style={inputBase}
          value={draft.description}
          onChange={(e) => onChange({ ...draft, description: e.target.value })}
        />
      </td>
      <td>
        <input
          className="bsp-input bsp-mono"
          style={{ ...inputBase, width: 80 }}
          value={draft.sizeDn ?? ""}
          onChange={(e) => onChange({ ...draft, sizeDn: e.target.value })}
        />
      </td>
      <td>
        <input
          className="bsp-input"
          style={{ ...inputBase, width: 110 }}
          value={draft.material ?? ""}
          onChange={(e) => onChange({ ...draft, material: e.target.value })}
        />
      </td>
      <td>
        <input
          className="bsp-input bsp-mono"
          style={{ ...inputBase, width: 70 }}
          type="number"
          min={0}
          step={1}
          value={draft.quantity}
          onChange={(e) => onChange({ ...draft, quantity: Number(e.target.value) })}
        />
      </td>
      <td>
        <input
          className="bsp-input bsp-mono"
          style={{ ...inputBase, width: 80 }}
          type="number"
          min={0}
          step={0.01}
          value={draft.lengthM ?? ""}
          onChange={(e) =>
            onChange({
              ...draft,
              lengthM: e.target.value === "" ? undefined : Number(e.target.value),
            })
          }
        />
      </td>
      <td>
        <input
          className="bsp-input bsp-mono"
          style={{ ...inputBase, width: 90 }}
          value={draft.sectionId ?? ""}
          onChange={(e) => onChange({ ...draft, sectionId: e.target.value })}
        />
      </td>
      <td style={{ display: "flex", gap: 6 }}>
        <button
          type="button"
          className="bsp-btn bsp-btn-primary bsp-btn-sm"
          onClick={onSave}
          disabled={busy}
          title="Save"
        >
          <Check size={14} />
        </button>
        <button
          type="button"
          className="bsp-btn bsp-btn-ghost bsp-btn-sm"
          onClick={onCancel}
          disabled={busy}
          title="Cancel"
        >
          <X size={14} />
        </button>
      </td>
    </tr>
  );
}
